import React from 'react';

// Institutional image provided by the user
const OFFICE_IMAGE = "https://customer-assets.emergentagent.com/job_advocacia-site-3/artifacts/gwufcvh9_SaveClip.App_473808906_623904546804929_3272142854418613558_n.jpg";

export const AboutSection = () => {
  return (
    <section 
      className="relative w-full bg-primary py-16 lg:py-24 overflow-hidden"
      data-testid="about-section"
      id="quem-somos"
    >
      {/* Container */}
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          
          {/* Left Side - Institutional Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-lg shadow-elegant">
              {/* Main Image */}
              <div className="aspect-[4/3] w-full">
                <img
                  src={OFFICE_IMAGE}
                  alt="Escritório Pessoa & Pessoa Advocacia"
                  className="w-full h-full object-cover object-center"
                  data-testid="about-office-image"
                />
              </div>
              
              {/* Subtle gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-navy/20 via-transparent to-transparent pointer-events-none" />
            </div>
            
            {/* Decorative accent element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-accent/30 rounded-lg -z-10 hidden lg:block" />
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-accent/10 rounded-lg -z-10 hidden lg:block" />
          </div>

          {/* Right Side - Text Content */}
          <div className="flex flex-col justify-center order-1 lg:order-2">
            {/* Small text above title */}
            <span 
              className="text-accent font-body text-sm font-medium tracking-[0.2em] uppercase mb-3 block"
              data-testid="about-subtitle"
            >
              Advocacia
            </span>
            
            {/* Main Title */}
            <h2 
              className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary-foreground font-semibold mb-6"
              data-testid="about-title"
            >
              Pessoa & Pessoa
            </h2>
            
            {/* Gold accent line */}
            <div className="w-20 h-0.5 bg-gradient-to-r from-accent to-gold-light mb-8" />
            
            {/* Institutional Description */}
            <div className="space-y-5" data-testid="about-description">
              <p className="text-primary-foreground/80 font-body text-base lg:text-lg leading-relaxed">
                O escritório <strong className="text-primary-foreground font-medium">Pessoa & Pessoa Advocacia</strong> nasceu 
                da união de profissionais apaixonados pelo Direito e comprometidos com a defesa dos seus clientes. 
                Com mais de <strong className="text-accent font-medium">15 anos de experiência</strong> no mercado 
                jurídico, construímos uma trajetória sólida baseada em resultados concretos e relacionamentos de confiança.
              </p>
              
              <p className="text-primary-foreground/80 font-body text-base lg:text-lg leading-relaxed">
                Ao longo dessa jornada, já conduzimos mais de <strong className="text-accent font-medium">2.000 processos</strong> nas 
                áreas de Direito de Família, Trabalhista, Civil e Empresarial, alcançando uma taxa de sucesso 
                superior a <strong className="text-accent font-medium">96%</strong> em causas julgadas. Cada 
                número representa uma história, uma família protegida, um direito conquistado.
              </p>
              
              <p className="text-primary-foreground/80 font-body text-base lg:text-lg leading-relaxed">
                Nosso compromisso vai além da técnica jurídica. Acreditamos em um atendimento 
                <strong className="text-primary-foreground font-medium"> humanizado</strong>, onde cada cliente é ouvido com 
                atenção e tratado com respeito. Trabalhamos com <strong className="text-primary-foreground font-medium">ética</strong>, 
                <strong className="text-primary-foreground font-medium"> transparência</strong> e dedicação integral, porque 
                entendemos que por trás de cada processo existe uma pessoa que confiou em nós para defender 
                o que é mais importante em sua vida.
              </p>
            </div>
            
            {/* Trust Badges/Indicators */}
            <div className="flex flex-wrap gap-4 mt-8" data-testid="about-badges">
              <div className="flex items-center gap-2 bg-primary-foreground/10 px-4 py-2 rounded-full">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-body text-sm text-primary-foreground font-medium">OAB Registrado</span>
              </div>
              
              <div className="flex items-center gap-2 bg-primary-foreground/10 px-4 py-2 rounded-full">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-body text-sm text-primary-foreground font-medium">+15 Anos de Experiência</span>
              </div>
              
              <div className="flex items-center gap-2 bg-primary-foreground/10 px-4 py-2 rounded-full">
                <svg className="w-5 h-5 text-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-body text-sm text-primary-foreground font-medium">+2.000 Processos</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-1/4 h-full opacity-5 pointer-events-none">
        <div className="absolute top-1/4 left-10 w-48 h-48 rounded-full bg-primary-foreground blur-3xl" />
        <div className="absolute bottom-1/4 left-20 w-32 h-32 rounded-full bg-accent blur-2xl" />
      </div>
    </section>
  );
};

export default AboutSection;
